import {
  AddUser1Icon,
  Box,
  GKButton,
  Grid2,
  PlusFilledIcon,
  Typography,
} from "components";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { useFormContext } from "react-hook-form";

const AdvisorOnboardingTypeSelect = () => {
  const { setValue } = useFormContext<AdvisorOnboardFormInterface>();

  const buttonData = [
    {
      title: "New / via KRA / Existing",
      description:
        "Seamlessly onboard new clients by manually entering details or fetching their data from KRA to begin their investment journey.",
      disable: false,
      icon: <PlusFilledIcon width={24} height={24} />,
      onClick: () => {
        setValue("activeStep", 1);
        setValue("type", "new");
      },
    },
    {
      title: "Client Self-Onboarding",
      description:
        "Enable hassle-free onboarding by sending a secure link for clients to complete their compliances and investment setup",
      icon: <AddUser1Icon width={24} height={24} />,
      disable: false,
      onClick: () => {
        setValue("activeStep", 1);
        setValue("type", "manual");
      },
    },
  ];

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={2} />
      <Grid2 size={8} display={"flex"} alignItems={"center"} gap={2}>
        {buttonData?.map((dataItem, index) => {
          return (
            <GKButton
              key={index}
              disabled={dataItem.disable}
              onClick={dataItem.onClick}
              variant="outlined"
              color="dark"
              fullWidth
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                p: 4,
                gap: 0.5,
                width: "100%",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  p: 1.2,
                  border: `1px solid var(--neutral-100)`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 2,
                }}
              >
                {dataItem.icon}
              </Box>
              <Typography fontWeight={600} color={"var(--black)"}>
                {dataItem.title}
              </Typography>
              <Typography textTransform={"none"}>
                {dataItem.description}
              </Typography>
            </GKButton>
          );
        })}
      </Grid2>
      <Grid2 size={2} />
    </Grid2>
  );
};

export default AdvisorOnboardingTypeSelect;
